import { rest } from "msw";
import { medicalHref } from '../../utils/constants';
import { medicalServicePost } from '../responseResolvers/misc';

export const medicalServiceHandlers = [rest.post(`${medicalHref}/api/persons/:personId/documents/extractMrz`, medicalServicePost)];